var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"navbar",class:_vm.classes},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('a',{staticClass:"nav-link",attrs:{"href":"https://www.instagram.com/therabbitholetea/","title":"Follow us on Instagram","data-placement":"bottom"}},[_c('i',{staticClass:"fab fa-instagram"}),_c('p',[_vm._v("Instagram")])])])
}]

export { render, staticRenderFns }